if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('is-active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('is-active');

      const activeImage = activeMedia.querySelector('img');
      if (activeImage && !activeImage.complete) {
        activeImage.loading = 'eager';
        activeImage.fetchPriority = 'high';
        this.classList.add('loading-active-media');
        const revealMedia = () => {
          this.classList.remove('loading-active-media');
          activeMedia.scrollIntoView({ block: 'center' });
        };
        activeImage.addEventListener('load', revealMedia, { once: true });
        activeImage.addEventListener('error', revealMedia, { once: true });
      } else {
        activeMedia.scrollIntoView({ block: 'center' });
      }

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}

// Warm the modal's full-size images in the background after page load, so
// the first popup open finds them cached instead of fetching on demand.
if (!window.__productModalPreload) {
  window.__productModalPreload = true;
  window.addEventListener('load', () => {
    const warm = () => {
      document.querySelectorAll('product-modal img[loading="lazy"]').forEach((img) => {
        img.loading = 'eager';
      });
    };
    if ('requestIdleCallback' in window) {
      requestIdleCallback(warm, { timeout: 4000 });
    } else {
      setTimeout(warm, 2500);
    }
  });
}
